export const VERIFY_WALMART_LOGIN = '/api/walmart/get-walmart-login-url';

export const VALIDATE_WALMART_FORM = '/api/walmart/validate-walmart-feed-data';

export const DOWNLOAD_WALMART_FORM = '/api/walmart/export-walmart-feed-data';

export const GET_WALMART_PRODUCT_SCHEMA =
  'api/walmart/get-walmart-product-schema';

export const GET_INITIAL_WALMART_PRODUCT_DATA =
  'api/walmart/get-walmart-product-data';

export const VALIDATE_WALMART_PRODUCT_DATA =
  '/api/walmart/validate-walmart-product-data';

export const GET_WALMART_PRODUCT_ASSETS = '/api/walmart/get-product-assets';

export const CHECK_ALLOW_POST_GDSN_WALMART_RECIPIENTS =
  '/api/walmart/check-post-gdsn-walmart-recipients';
